const STEPS = {
  DATETICKETS: 1,
  EVENTS: 2,
  PARTY: 3,
  ADDONS: 4
}

const PATHS = {
  DEFAULT: [STEPS.DATETICKETS, STEPS.EVENTS, STEPS.PARTY, STEPS.ADDONS],
  FROMEE: [STEPS.PARTY, STEPS.DATETICKETS, STEPS.EVENTS, STEPS.ADDONS]
}

export { STEPS, PATHS }
